import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Service-health dashboard route (`/integrations/health`). Super-admin only —
 * it surfaces backend infrastructure status. Lazy-loaded to keep it off the
 * initial authenticated bundle.
 */
const HealthPage = lazy(() => import('~/features/integrations/pages/health-page'));

// Declares the section-wide subsidiary scope (`sc`) so the integrations tab bar can
// carry the picked subsidiary onto this route — matches the sibling routes.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/integrations/health')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <HealthPage />
    </Suspense>
  ),
});
